export const ROUNDED_AMOUNT = 500;

export const STEP_RANGE_AMOUNT = 500;

export const CUSTOM_RANGE_PADDING = 5000;
